import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist';

import actions from './actions'
import getters from './getters.coffee'
import mutations from './mutations.coffee'
import es6Mutations from './es6Mutations'

import { nodeApi } from '../config'

Vue.use(Vuex)

const PERSIST_KEY = 'teachee-v1.0.3';

const onQuotaExceeded = (storage, error) => {
  // Only drop our own persisted state blob so a re-save can succeed on the retry.
  // Never storage.clear(): that also wipes the auth token and every other key,
  // logging the user out and losing unrelated data.
  console.info('Storage quota exceeded, dropping persisted store state');
  storage.removeItem(PERSIST_KEY);
}

// console.log('nodeApi is ', nodeApi)

const vuexLocalStorage = new VuexPersist({
  key: PERSIST_KEY, // The key to store the state on in the storage provider.
  storage: window.localStorage, // or window.sessionStorage or localForage
  reducer: (state) => {
    return ({
      voiceGender: state.voiceGender,
      activities: state.activities,
      visitedLessons: state.visitedLessons,
      lastLessons: state.lastLessons,
      students: state.students,
      user: state.user,
      defaultHours: state.defaultHours,
      purchases: state.purchases,
      voices: state.voices,
      // allLessons is refetched in LessonsPage.created() on every load, so it
      // never needs persisting — and it was the main driver of the localStorage
      // quota overflow (QuotaExceededError on teachee-v1.0.3).
      usedLanguages: state.usedLanguages,
      compactMode: state.compactMode,
      navCompactMode: state.navCompactMode,
      showShortIpaVersion: state.showShortIpaVersion,
    })
  },
  saveState: (key, state, storage) => {
    try {
      storage.setItem(key, JSON.stringify(state));
    } catch (error) {
      if (error.name === 'QuotaExceededError') {
        onQuotaExceeded(storage, error)
        try {
          storage.setItem(key, JSON.stringify(state));
        } catch (retryError) {
          // The blob alone exceeds quota, so dropping the stale copy didn't help.
          // Skip persisting this cycle rather than throwing uncaught (state stays
          // in memory and is refetched from the API on reload).
          console.warn('Persisted store still exceeds quota after cleanup; skipping save');
        }
      } else {
        throw error; // Re-throw if it's not a QuotaExceededError
      }
    }
  },

  assertStorage: function(storage) {
    try {
      const testKey = '__vue-persist_test__';
      storage.setItem(testKey, 'test');
      storage.removeItem(testKey);
    } catch (error) {
      onQuotaExceeded(storage, error)
    }
  }
  // Function that passes the state and returns the state with only the objects you want to store.
  // reducer: state => state,
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
})

export const store = new Vuex.Store({
  state: {
    isConnected: false,
    isEditingSentenceContent: false,
    compactMode: false,
    navCompactMode: false,
    apiUrl: nodeApi,
    uuid: null,
    voiceGender: 'male',
    layout: 'no-layout',
    layoutBackground: '',
    student: {},
    students: [],
    purchases: [],
    usedLanguages: [],
    purchase: {},
    lastActivity: new Date(),
    showShortIpaVersion: true,
    user: {},
    storageStats: 0,
    pack: {
      user: {}
    },
    packs: [],
    lesson: {},
    lessons: [],
    lessonsPagination: null,
    activities: [],
    visitedLessons: [],
    lastLessons: [],
    voices: {
      'en-US': "Samantha",
      'en-GB': "Daniel",
      'de-DE': "Anna",
      'hu-HU': "Mariska",
      'fr-FR': 'Thomas',
      'it-IT': 'Google italiano',
      'pt-BR': 'Google português do Brasil',
      'pt-PT': 'Joana',
      'zh-CN': 'Ting-Ting',
      'ar-SA': 'Maged',
      'es-ES': 'Jorge',
      'ko-KR': 'Yuna',
      'bg-BG': 'Daria',
      "ru-RU": "Milena",
      "cs-CZ": "Zuzana",
      "he-IL": "Carmit",
      "hi-IN": "Lekha",
      "ja-JP": "Kyoko",
      "id-ID": "Damayanti",
      "nb-NO": "Nora",
      "pl-PL": "Zosia",
      "ro-RO": "Ioana",
      "sk-SK": "Laura",
      "th-TH": "Kanya",
      "da-DK": "Sara",
      "el-GR": "Melina",
      "fi-FI": "Satu",
    },
    sentences: [{}],
    sentencesOptions: [],
    categories: [],
    allLessons: [],
    usersById: {},
    lastAudio: {},
    defaultHours: [8, 9, 10, 11, 13, 14, 15, 16],
  },
  plugins: [vuexLocalStorage.plugin],
  actions,
  getters,
  mutations: Object.assign({}, mutations, es6Mutations)
})
